var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:_vm.center ? 'align-center' : '',attrs:{"column":""}},[(_vm.showSkeleton)?_c('div',{staticClass:"skeleton-animation",style:(_vm.styleGenerator(_vm.height, _vm.width))}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }